module.exports = __webpack_public_path__ + "static/media/101207719_2934567666663069_4981561480903131136_n.0f11054c.jpg";